import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/hallowmas/2024/Index.vue')
const IndexSplus = () => import('../activity/hallowmas/2024-splus/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/hallowmas/2024',
  name: 'activity_hallowmas_2024',
  component: Index,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '万圣狂欢节',
  },
}

export const indexSplusRoute: RouteConfig = {
  path: '/activity/hallowmas/2024-splus',
  name: 'activity_hallowmas_2024_splus',
  component: IndexSplus,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: 'S+奇妙捣蛋献礼',
  },
}

export default [indexRoute, indexSplusRoute]
